module.exports = __webpack_public_path__ + "static/media/TemplateBusinessCard.0caa33a3.png";